// The WeChat module (DESIGN.md, Integrations): sign-in inside WeChat, and sending games and
// invitations in WeChat as cards. Registered in modules.js.
import { addTexts } from '@/texts';
import { zh, errors } from './texts';
import store from '@/store';
import WeChatActionButton from './WeChatActionButton';
import WeChatSettingsSection from './WeChatSettingsSection';
import WeChatNotificationSection from './WeChatNotificationSection';
import { startRetries } from './notifications';
import { insideWeChat, available, loadSettings, authorize, linkSignedIn } from './wechat';
import WeChatReturnPage from './WeChatReturnPage';
import WeChatSignInButton from './WeChatSignInButton';
import WeChatAccountSection from './WeChatAccountSection';
import WeChatAdminSection from './WeChatAdminSection';
import WeChatSendSection from './WeChatSendSection';

export default {
  async init({ router, extensions }) {
    addTexts(zh, errors);
    router.addRoute({ path: '/wechat/return', name: 'wechat-return', component: WeChatReturnPage });
    extensions.accountSections.push(WeChatAccountSection);
    extensions.adminSections.push({ key: 'wechat', title: 'admin-wechat', component: WeChatAdminSection });

    await loadSettings();
    extensions.actionButton = WeChatActionButton;
    extensions.settingsSections.push(WeChatSettingsSection);
    extensions.notificationSections.push(WeChatNotificationSection);
    startRetries();
    if (!insideWeChat()) return;
    if (!available()) return;
    extensions.signInProviders.push({ available, signIn: next => authorize('snsapi_base', next) });
    extensions.signInSections.push(WeChatSignInButton);
    // WeChat is personal, and the next page would sign straight back in.
    extensions.hideSignOut = true;
    extensions.shareSections.push(WeChatSendSection);
    extensions.createOpponentInviteLabel = 'create-opponent-invite-wechat';
    // A player signed in without WeChat gets this WeChat linked on the way to the next page.
    router.beforeEach(async (to, from, next) => {
      const u = store.state.user;
      if (!u || to.name === 'wechat-return' || to.name === 'admin') return next();
      if (await linkSignedIn(u, to.fullPath)) return next(false);
      next();
    });
  },
};
